/* smart-answer-card.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "./smart-answer-card.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Box } from '@atlaskit/primitives/compiled';
import UFOCustomCohortData from '@atlaskit/react-ufo/custom-cohort-data';
import UFOCustomData from '@atlaskit/react-ufo/custom-data';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import UFOSegment from '@atlaskit/react-ufo/segment';
import { AnimatedWrapper } from '@atlassian/ai-common';
import { AIAnswerError } from '../../ai-answer-dialog/ai-answer-body/ai-answer-result/ai-answer-error';
import { useAIAnswerContext } from '../../ai-answer-dialog/ai-answer-context';
import { aiAnswerCollapseClicked, aiAnswerExpandClicked, onAIAnswerResultFirstByteShown } from '../../ai-answer-dialog/analytics';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics/hooks/use-sain-usage';
import { useAnalytics } from '../../common/controller/analytics/use-analytics';
import { SmartAnswerCardBodyGenerating } from '../common/ui/smart-answer-card-body-generating';
import { SmartAnswerCardBodyComplete } from './smart-answer-card-body-complete';
import { SmartAnswerCardBodyStreaming } from './smart-answer-card-body-streaming';
var styles = {
  fullWidth: "_1bsbauwl _p12f1osq",
  container: "_2rko12b0 _189ee4h9 _1dqonqa1 _1h6d1l7x",
  interactive: "_80omtlke"
};
function SmartAnswerCardComponent(_ref) {
  var _partialResponse$part;
  var onFMPReached = _ref.onFMPReached,
    onAnswerExpandedChange = _ref.onAnswerExpandedChange,
    queryIntent = _ref.queryIntent;
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var containerRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    didUserTriggerCollapse = _useState4[0],
    setDidUserTriggerCollapse = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isVisibleTextComplete = _useState6[0],
    setIsVisibleTextComplete = _useState6[1];
  var componentRenderTimeRef = useRef(Date.now());
  var firstByteEventFiredRef = useRef(false);
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    hasError = _useAIAnswerContext.hasError,
    isAnswered = _useAIAnswerContext.isAnswered,
    loading = _useAIAnswerContext.loading,
    partialResponse = _useAIAnswerContext.partialResponse;
  var cloudId = commonAttributes.cloudId,
    queryHash = commonAttributes.queryHash,
    searchSessionId = commonAttributes.searchSessionId;
  var _useAnalytics = useAnalytics(),
    _useAnalytics2 = _slicedToArray(_useAnalytics, 1),
    fireAnalyticsEvent = _useAnalytics2[0];
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var streamingText = (_partialResponse$part = partialResponse === null || partialResponse === void 0 ? void 0 : partialResponse.partialNlpResult) !== null && _partialResponse$part !== void 0 ? _partialResponse$part : '';
  var _useState7 = useState(streamingText),
    _useState8 = _slicedToArray(_useState7, 2),
    streamingTextToDisplay = _useState8[0],
    setStreamingTextToDisplay = _useState8[1];
  var isNewSainLoadingEnabled = fg('kd_sain_rovo_loading');
  useEffect(function () {
    if (streamingText.length > 0 && !firstByteEventFiredRef.current) {
      fireAnalyticsEvent(onAIAnswerResultFirstByteShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        timeToFirstByte: Date.now() - componentRenderTimeRef.current
      })));
      firstByteEventFiredRef.current = true;
    }
  }, [streamingText, commonAttributes, fireAnalyticsEvent]);
  useEffect(function () {
    if (collapsed && !isVisibleTextComplete) {
      setStreamingTextToDisplay(streamingText);
    } else if (!collapsed) {
      setStreamingTextToDisplay(streamingText);
    }
  }, [collapsed, isVisibleTextComplete, streamingText]);

  // Notify context when collapsed state changes
  useEffect(function () {
    onAnswerExpandedChange === null || onAnswerExpandedChange === void 0 || onAnswerExpandedChange(!collapsed);
  }, [collapsed, onAnswerExpandedChange]);
  useEffect(function () {
    if (!loading && !hasError && !isVisibleTextComplete) {
      setIsVisibleTextComplete(true);
      onFMPReached === null || onFMPReached === void 0 || onFMPReached(); // Mark FMP as reached for cached answers
    }
  }, [loading, hasError, isVisibleTextComplete, onFMPReached]);

  // use useEffect to trigger analytics event in order to avoid needing to
  // pass commonAttributes as a dependency to handleExpandCollapseButtonClick
  // and thus avoid re-rendering SmartAnswerCardBodyStreaming with every
  // update to commonAttributes (which gets updated with the streamed text)
  useEffect(function () {
    if (didUserTriggerCollapse) {
      fireAnalyticsEvent(aiAnswerCollapseClicked(commonAttributes));
    }
  }, [didUserTriggerCollapse, commonAttributes, fireAnalyticsEvent]);
  var handleExpandCollapseButtonClick = useCallback(function () {
    if (collapsed) {
      setCollapsed(false);
      setDidUserTriggerCollapse(false);
    } else {
      setCollapsed(true);
      setDidUserTriggerCollapse(true);
    }
  }, [collapsed]);
  var handleVisibleTextComplete = useCallback(function () {
    setIsVisibleTextComplete(true);
    onFMPReached === null || onFMPReached === void 0 || onFMPReached(); // Mark FMP as reached for streaming answers
  }, [onFMPReached]);
  var handleContainerClick = function handleContainerClick(event) {
    var _window$getSelection$, _window$getSelection, _containerRef$current, _containerRef$current2;
    var selection = (_window$getSelection$ = (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.toString()) !== null && _window$getSelection$ !== void 0 ? _window$getSelection$ : '';
    // Highlighting text should not expand the card
    var hasHighlightedText = selection.length > 0;
    // Clicking in a feedback modal or flag should not expand the card
    var isClickingOnContainer = (_containerRef$current = (_containerRef$current2 = containerRef.current) === null || _containerRef$current2 === void 0 ? void 0 : _containerRef$current2.contains(event.target)) !== null && _containerRef$current !== void 0 ? _containerRef$current : false;
    if (collapsed && !hasHighlightedText && isClickingOnContainer) {
      setCollapsed(false);
      fireAnalyticsEvent(aiAnswerExpandClicked(commonAttributes));
      fireSAINUsageEvent({
        metCriteria: SainAction.EXPAND_CLICKED,
        commonAttributes: commonAttributes
      });
    }
  };
  if (hasError) {
    return /*#__PURE__*/React.createElement(Box, {
      xcss: styles.fullWidth
    }, /*#__PURE__*/React.createElement(AIAnswerError, null));
  }
  var content = null;
  if (!isAnswered && (loading || loading === undefined)) {
    if (!partialResponse) {
      !isNewSainLoadingEnabled ? content = /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(SmartAnswerCardBodyGenerating, {
        queryIntent: queryIntent
      })) : content = /*#__PURE__*/React.createElement(SmartAnswerCardBodyGenerating, {
        queryIntent: queryIntent
      });
    } else {
      !isNewSainLoadingEnabled ? content = /*#__PURE__*/React.createElement(AnimatedWrapper, null, /*#__PURE__*/React.createElement(Box, {
        xcss: collapsed ? styles.interactive : undefined,
        onClick: handleContainerClick,
        ref: containerRef
      }, /*#__PURE__*/React.createElement(SmartAnswerCardBodyStreaming, {
        cloudId: cloudId,
        collapsed: collapsed,
        onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        onVisibleTextComplete: handleVisibleTextComplete,
        streamedTextToDisplay: streamingTextToDisplay,
        queryIntent: queryIntent
      }))) : content = /*#__PURE__*/React.createElement(SmartAnswerCardBodyStreaming, {
        cloudId: cloudId,
        collapsed: collapsed,
        onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
        onVisibleTextComplete: handleVisibleTextComplete,
        streamedTextToDisplay: streamingTextToDisplay,
        queryIntent: queryIntent
      });
    }
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UFOLoadHold, {
      name: "search-ai-dialog-all-text-loading"
    }), fg('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UFOCustomCohortData, {
      dataKey: "queryHash",
      value: queryHash
    }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
      dataKey: "searchSessionId",
      value: searchSessionId
    }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
      dataKey: "queryIntent",
      value: queryIntent
    })) : /*#__PURE__*/React.createElement(UFOCustomData, {
      data: {
        queryHash: queryHash,
        searchSessionId: searchSessionId,
        queryIntent: queryIntent
      }
    }), content);
  } else {
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
      xcss: cx(!isNewSainLoadingEnabled ? styles.container : undefined, collapsed ? styles.interactive : undefined),
      onClick: handleContainerClick,
      ref: containerRef
    }, /*#__PURE__*/React.createElement(SmartAnswerCardBodyComplete, {
      collapsed: collapsed,
      onExpandCollapseButtonClick: handleExpandCollapseButtonClick,
      queryIntent: queryIntent
    })));
  }
  content = /*#__PURE__*/React.createElement(UFOSegment, {
    name: "search-ai-dialog-all-text"
  }, /*#__PURE__*/React.createElement(UFOSegment, {
    name: "search-ai-dialog-visible-text"
  }, isVisibleTextComplete ? null : /*#__PURE__*/React.createElement(UFOLoadHold, {
    name: "search-ai-dialog-visible-text-loading"
  }), fg('platform_ufo_custom_cohort_data_migration') ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "queryHash",
    value: queryHash
  }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "searchSessionId",
    value: searchSessionId
  }), /*#__PURE__*/React.createElement(UFOCustomCohortData, {
    dataKey: "queryIntent",
    value: queryIntent
  })) : /*#__PURE__*/React.createElement(UFOCustomData, {
    data: {
      queryHash: queryHash,
      searchSessionId: searchSessionId,
      queryIntent: queryIntent
    }
  }), content));
  if (isNewSainLoadingEnabled) {
    return /*#__PURE__*/React.createElement(AnimatedWrapper, {
      isAnswerComplete: isAnswered && !loading
    }, /*#__PURE__*/React.createElement(Box, {
      xcss: styles.fullWidth
    }, content));
  }
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.fullWidth
  }, content);
}
export function SmartAnswerCard(_ref2) {
  var onFMPReached = _ref2.onFMPReached,
    onAnswerExpandedChange = _ref2.onAnswerExpandedChange,
    queryIntent = _ref2.queryIntent;
  return /*#__PURE__*/React.createElement(UFOSegment, {
    name: "smart-answer-card"
  }, /*#__PURE__*/React.createElement(SmartAnswerCardComponent, {
    onFMPReached: onFMPReached,
    onAnswerExpandedChange: onAnswerExpandedChange,
    queryIntent: queryIntent
  }));
}